import { DataPercentageComputed } from 'big-data';

export function getPipedWaterAnswersValues(data: DataPercentageComputed[]) {
  const yes = data.filter((d) => d.name.toLowerCase() === 'sim');
  const no = data.filter((d) => d.name.toLowerCase() === 'não');

  return [...yes, ...no].map((d) => d.percentageValue.toFixed(2));
}
